import React, {useEffect, useState} from 'react';
import StudentDataService from '../../services/student/StudentService';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import AddStudentPanel from './addStudentPanel';
import ConfigService from '../../services/config/ConfigService';
import Modal from 'react-modal';
import ClassesPanel from './classesPanel';

export default function Students(props) {
  const [students, setStudents] = useState();
  const [enrollConfirm, setEnrollConfirm] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [termsRead, setTermsRead] = useState(false);
  const [schoolYears, setSchoolYears] = useState();
  const [enrolmentNotes, setEnrolmentNotes] = useState('');

  useEffect(() => {
    document.title = "Cool Kids English - Students"

    retrieveStudents();
    retrieveSchoolYears();
  }, []);

  const retrieveSchoolYears = async() => {
    const incomingSchoolYears = await ConfigService.getSchoolYears();

    setSchoolYears(incomingSchoolYears);
  }

  const retrieveStudents = async() => {
    const incomingStudents = await StudentDataService.getAllForParent();
    console.log('Got students for this parent', students);
    setStudents(incomingStudents);
  }

  const enrolYear = (student, schoolYear) => {
    setEnrollConfirm({student, schoolYear});
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const showTermsAndConditions = () => {
    window.open('http://www.coolkidsenglish.at/extras/cke-terms.pdf', '_blank', 'noopener,noreferrer');
    setTermsRead(true);
  }

  const confirmEnrolment = async () => {
    await StudentDataService.enroll(enrollConfirm.student, enrollConfirm.schoolYear, enrolmentNotes);
    setEnrollConfirm(null);
    retrieveStudents();
  }

  const cancelEnrolment = () => {
    setEnrollConfirm(null);
  }
  
  const renderEnrolments = student => {
    if (enrollConfirm) {
      return (
        <Modal
          isOpen={true}
          onAfterOpen={() => console.log('after open')}
          onRequestClose={() => setEnrollConfirm(null)}
          style={customStyles}
          contentLabel={`Confirm Enrolment for ${enrollConfirm.student.firstName} ${enrollConfirm.student.lastName}`}
        >
          <h2>Confirm Enrolment</h2>
          <div>Do you <span style={{fontWeight: 'bold'}}>{enrollConfirm.student.firstName} {enrollConfirm.student.lastName}</span> for school year <span style={{fontWeight: 'bold'}}>{enrollConfirm.schoolYear}?</span></div>
          &nbsp;
          <div>Please make sure you have read the <a href="#" target="_blank" rel="noreferrer" onClick={showTermsAndConditions}>Terms and Conditions</a></div>
          &nbsp;
          {
            enrollConfirm.student.school?.parentInfo && <div>
              <div>Please also review the following information for <span style={{fontWeight: 'bold'}}>{enrollConfirm.student.school?.name}</span></div>
              <div style={{fontStyle: 'italic'}}>{enrollConfirm.student.school?.parentInfo}</div>
              &nbsp;
            </div>
          }
          <form>
            <div className="form-group">
              <label htmlFor="title">Additional Information
              <div className="smallInfo">Please state your preferred day, or other relevant information.</div>

              </label>
              
              <textarea
                style={{height: 100}}
                type="text"
                className="form-control"
                id="enrolmentNotes"
                name="enrolmentNotes"
                value={enrolmentNotes}
                onChange={(e) => {
                  console.log('enrol notes', e.target.value);
                  setEnrolmentNotes(e.target.value)}
                }
                />
            </div>
            <div className="buttonRow">
              <button
                type="submit"
                disabled={!termsRead}
                className="btn btn-outline-primary"
                onClick={confirmEnrolment}
                >
                  Confirm Enrollment
                </button>
                <button
                type="submit"
                className="btn btn-outline-danger"
                onClick={cancelEnrolment}
                >
                  Cancel Enrollment
                </button>
              </div>
          </form>
        </Modal>
      ) 
    } else if (schoolYears) {
      return schoolYears.map(s => {
        if (student.enrolments.find(e => s.year === e.schoolYear)) {
          //Kid is already enrolled for this year
          return (
            <div style={{display: 'flex', flexDirection: 'row', height: 40}}>
              <div style={{display: 'flex', flex: 1}}>{s.year}</div>
              <div style={{display: 'flex', flex: 1}}>Enrolled</div>
            </div>
          )
        } else {
          return (
            <div style={{display: 'flex', flexDirection: 'row', height: 40}}>
              <div style={{display: 'flex', flex: 1}}>{s.year}</div>
              <div style={{display: 'flex', flex: 1}}>
                <button
                type="submit"
                className="btn btn-outline-primary"
                onClick={() => enrolYear(student, s.year)}
                >
                  Press to Enroll for {s.year}
                </button>
              </div>
            </div>
          )
        }
      })
    }
  }

  const renderStudentTab = student => {
    return (
      <TabPanel>
        <h2>{student.firstName} {student.lastName}</h2>
        <div style={{margin: 20, padding: 0, backgroundColor: '#eeeeff'}}>
          <h3>School Year Enrolments</h3>
          <div style={{width: '50%'}}>
            { renderEnrolments(student) }
          </div>
        </div>
        <div style={{margin: 20, padding: 0, backgroundColor: '#eeffee'}}>
          <h3>Class Enrolments</h3>
           <ClassesPanel classes={student.classes} student={student} props={props}/>
        </div>
      </TabPanel>
    )
  };

  const renderAddStudentTab = () => {
    return (
      <TabPanel>
        <AddStudentPanel props={props} savedCallback={studentSavedCallback}/>
      </TabPanel>
    )
  }

  const studentSavedCallback = () => {
    retrieveStudents();
    setTabIndex(students.length+1)
  }

  return(
    <div style={{margin: 5}}>
      <h1>Your Students</h1>      
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          { students?.map(s => <Tab>{s.firstName} {s.lastName}</Tab>)}
          <Tab><div style={{backgroundColor: '#63a3be', color: 'white', paddingRight: 10, paddingLeft: 10}}>Register New Student</div></Tab>
        </TabList>
        &nbsp;
        { students?.map(s => renderStudentTab(s))}
        { renderAddStudentTab() }
      </Tabs>
    </div>
  )
}
